import {TypeAdresseComplete} from './TypeAdresseComplete';
export class TypeAnnexeATA {

	public tech: TypeAdresseComplete[];

	public adm: TypeAdresseComplete[];

	constructor() { 
		 		this.tech = [];
		this.adm = [];
 
	}
}
